import React from 'react';
import styled from 'styled-components';
import { ImageStyle, Colors } from 'stylecomponents';
import PropTypes from 'prop-types';
import CupoySrefView from 'components/commons/router/CupoySrefView';

const Container = styled.div`
  padding: 25px;
  border-right: solid 1px #e8e8e8;
  border-bottom: solid 1px #e8e8e8;

  &:nth-child(3n+3) {
    border-right: none;
  }
  &:nth-child(4) {
    border-bottom: none;
  }
  &:nth-child(5) {
    border-bottom: none;
  }
  &:nth-child(6) {
    border-bottom: none;
  }
`;

const TileImgWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 75%;
`;

const TileImg = ImageStyle.extend`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Title = styled.div`
  text-align: center;
  margin-top: 16px;
  font-size: 18px;
  color: ${Colors.Dark3};
`

const Tile = props => {

  const {
    params = {},
    title,
    img,
    stateName,
  } = props;

  return (
    <CupoySrefView
      statename={stateName}
      stylecomponent={Container}
      params={params}
    >
      <TileImgWrapper>
        <TileImg img={img} />
      </TileImgWrapper>
      <Title>{title}</Title>
    </CupoySrefView>
  )
}

Tile.propTypes = {
  title: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  stateName: PropTypes.string.isRequired,
  params: PropTypes.object,
};

export default Tile;